import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import {
  CLEAR_SHELF,
  CLEAR_SHELVES,
  FLAG_GETTING_SHELVES,
  FLAG_SHELF_ACTIVITY,
  GET_SHELF,
  GET_SHELF_SPACE,
  GET_SHELVES,
} from '../../../actions/types';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
    space: Immutable.Map(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_SHELVES:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_SHELVES:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_SHELVES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_SHELF_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_SHELF:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_SHELF:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case GET_SHELF_SPACE:
      return state.setIn(['current', 'space'], Immutable.Map(action.payload));
    default:
      return state;
  }
};
